export type ColumnKey = 'id' | 'subject' | 'requester' | 'assignee' | 'priority' | 'created' | 'labels' | 'project' | 'sla';

export interface ColumnDef {
	key: ColumnKey;
	label: string;
	/** CSS grid track size used for the lg-breakpoint grid template. */
	width: string;
	/** Whether the user can hide this column from the Columns dropdown. */
	toggleable: boolean;
	/** Initial visibility before the user has interacted with the dropdown. */
	defaultVisible: boolean;
}

// Order = visual order in the lg grid.
export const LG_COLUMNS: readonly ColumnDef[] = [
	{key: 'id', label: 'ID', width: '4rem', toggleable: false, defaultVisible: true},
	{key: 'subject', label: 'Subject', width: '1fr', toggleable: false, defaultVisible: true},
	{key: 'requester', label: 'Requester', width: '150px', toggleable: true, defaultVisible: true},
	{key: 'assignee', label: 'Assignee', width: '140px', toggleable: true, defaultVisible: true},
	{key: 'priority', label: 'Priority', width: '100px', toggleable: true, defaultVisible: true},
	{key: 'created', label: 'Created', width: '130px', toggleable: true, defaultVisible: true},
	{key: 'labels', label: 'Labels', width: '200px', toggleable: true, defaultVisible: false},
	{key: 'project', label: 'Project', width: '180px', toggleable: false, defaultVisible: true},
	{key: 'sla', label: 'SLA', width: '120px', toggleable: false, defaultVisible: true},
];

export const TOGGLEABLE_COLUMNS: readonly ColumnDef[] = LG_COLUMNS.filter(c => c.toggleable);

export const DEFAULT_VISIBLE_COLUMN_KEYS: ReadonlySet<ColumnKey> = new Set(
	LG_COLUMNS.filter(c => c.defaultVisible).map(c => c.key)
);

export const ALWAYS_ON_COLUMN_KEYS: ReadonlySet<ColumnKey> = new Set(LG_COLUMNS.filter(c => !c.toggleable).map(c => c.key));
